import { layoutPaddingContextInitialState } from './layoutPadding.constants';
import { LayoutPaddingContextType } from './layoutPadding.types';

import { createTypeSafeContext } from '~/core/utils';

const [useLayoutPaddingContext, LayoutPaddingContext] =
  createTypeSafeContext<LayoutPaddingContextType>(
    layoutPaddingContextInitialState
  );

export { LayoutPaddingContext, useLayoutPaddingContext };
